import {sortByKey} from 'presentation/utils';

import {GetNeighborhoodsDentalGuideParams} from 'domain/usecases';
import {makeGetNeighborhoodsDentalGuide} from 'main/factories/usecases';

async function getOdontoDistricts(params: GetNeighborhoodsDentalGuideParams) {
	const {cdUf, cdEspecialidade, nmCidade, cdPlanoANS} = params;
	if (!cdUf || !nmCidade || !cdEspecialidade || !cdPlanoANS.length) {
		return [];
	}

	const districts = await makeGetNeighborhoodsDentalGuide().get(params);

	if (!districts) return [];

	const filteredDistricts = districts.bairros.filter(district => district.nmBairro);

	const sortedDistrictsByName = sortByKey(filteredDistricts, 'nmBairro');

	const parsedDistricts = sortedDistrictsByName.map(district => ({
		state: district?.cdUf,
		city: district?.nmCidade,
		district: district?.nmBairro,
	}));

	return parsedDistricts;
}

export {getOdontoDistricts};
